module.exports = __webpack_public_path__ + "static/media/p1000.c9ebbfd6.png";